//returns the number of words in that are common in big and small

const compareStrings = (big = "", small = "") => {
	if (!big) return false;
	let count = 0;
	small
		.toString()
		.toLowerCase()
		.trim()
		.split(" ")
		.forEach((word) => {
			if (big.toLowerCase().includes(word)) count++;
		});
	return count;
};

export default compareStrings;
